import type { ReactNode } from "react";

import { cn } from "@flare/ui";

export function ActionsContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn("text-center", className)}>{children}</div>;
}
